export default __webpack_public_path__ + "static/media/thumbnail_blog_21.15ef6d79.jpg";